import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        /**
         * if hsys != undefined = take it 
         * else = false
         */
        hsys: window.localStorage.getItem("hoursSystem") != null ? window.localStorage.getItem("hoursSystem") : false,
        // hsys: true,
        
        
    },
    
});